import jSecure from "@linkedin/jsecure"
// @todo Later refactoring. Make these class methods for upload related classes

/* NOTE: supplant was modified a little to handle the case of
{ and } being converted to '%7B' and '%7D' in href and src attributes.*/
String.prototype.supplant = function (replacements) {
  return this.replace(/\{([^{}]*)\}|%7B([a-z-_]*)%7D/g, function (placeholder, placeholder_key, default_value) {
    let substitution = replacements[default_value]

    if (placeholder_key) {
      substitution = replacements[placeholder_key]
    }

    if (typeof substitution === "string" || typeof substitution === "number") {
      return jSecure.htmlEncode(substitution)
    }
    return jSecure.htmlEncode(placeholder)
  })
}
/* String.prototype.supplant = function (o) {
 return this.replace(/{([^{}]*)}/g,
 function (a, b) {
 var r = o[b]; return typeof r === 'string' || typeof r === 'number' ? r : a; }); };*/

// few function copied from prototype library, for title generation etc.
String.prototype.underscore = function () {
  return this.replace(/::/, "/")
    .replace(/([A-Z]+)([A-Z][a-z])/, "$1_$2")
    .replace(/([a-z\d])([A-Z])/, "$1_$2")
    .replace(/_/, " ")
    .toLowerCase()
}
String.prototype.dasherize = function () {
  return this.replace(/_/, "-")
}
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.substring(1).toLowerCase()
}
String.prototype.escapeHTML = function () {
  return String(this).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
} // NOTE: jquery needed
//

export const gen_file_title = function (n) {
  let r = n
    .replace("'|\"", "")
    .underscore()
    .dasherize()
    .replace(/-/, " ")
    .replace(/\w+/, function (match) {
      return match.capitalize()
    })
  return r
}

export const file_basename = function (filename) {
  let str = "" + filename
  let brkpoint = str.lastIndexOf(".")
  brkpoint = brkpoint != -1 ? brkpoint : str.length
  return str.substr(0, brkpoint)
}

export const file_extension = function (filename) {
  let str = "" + filename
  let i = str.lastIndexOf(".")
  i = i != -1 ? i : str.length
  return str.substr(i + 1, str.length)
}

export const check_extension = function (fn, extensions) {
  const exts = fn.split(".")
  const ext = exts[exts.length - 1]
  if (extensions[ext]) {
    return true
  } else {
    alert(ext + " file type not supported")
    return false
  }
}
